import { render, staticRenderFns } from "./universitiesList.vue?vue&type=template&id=bb9b64e8&scoped=true&"
import script from "./universitiesList.vue?vue&type=script&lang=js&"
export * from "./universitiesList.vue?vue&type=script&lang=js&"
import style0 from "./universitiesList.vue?vue&type=style&index=0&id=bb9b64e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b64e8",
  null
  
)

export default component.exports